import classNames from 'classnames/bind';
import React, { InputHTMLAttributes, forwardRef, useId } from 'react';

import { WarningNotifRed } from '../../assets/icons/Icons';
import Styles from './freetext.module.scss';

const cx = classNames.bind(Styles);

interface FreeTextProps extends InputHTMLAttributes<HTMLInputElement> {
  showLabel?: boolean;
  label?: string | React.ReactNode;
  /** will highlight the input and indicate that it has an error */
  error?: boolean;
  /** Message to be displayed along with the error highlighting, wil not display if there is no error */
  errorMessage?: string;
  'aria-label'?: string;
  fullWidth?: boolean;
}

const FreeText = forwardRef<HTMLInputElement, FreeTextProps>(
  (
    {
      label,
      showLabel = !!label,
      disabled,
      id,
      error,
      errorMessage,
      fullWidth,
      className,
      placeholder = 'Type Something...',
      ...otherProps
    },
    ref,
  ) => {
    const elementId = id || useId();

    return (
      <div
        className={cx('form-element', 'container', { 'container-fullwidth': fullWidth, fw: fullWidth }, className)}
        data-testid='free-text'>
        <label
          htmlFor={elementId}
          className={cx({ 'sr-only': !showLabel, label: showLabel, 'label--disabled': showLabel && disabled })}>
          {label}
        </label>
        <input
          type='text'
          disabled={disabled}
          className={cx('freetext', { 'freetext--error': error })}
          id={elementId}
          ref={ref}
          placeholder={placeholder}
          {...otherProps}></input>
        {error ? (
          <p className={cx('error-message')}>
            {WarningNotifRed} {errorMessage}
          </p>
        ) : null}
      </div>
    );
  },
);

FreeText.displayName = 'FreeText';

export default FreeText;
